import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PanelComponent from '../../../../components/stateful/PanelComponent/PanelComponent';
import EditableRichText from '../../../../../src/web/containers/EditableRichText';
import PlaceholderIcon from '../../../../../modules/react/components/stateless/PlaceholderIcon';
import styles from './AccordionEditItem.scss';

const propTypes = {
  item: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  saveTextContent: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  panelCloseStatesEditMode: PropTypes.object.isRequired,
};

const defaultProps = {};

const AccordionEditItem = ({ item, isEditing,
  saveTextContent, isTitleInvalid, isBodyInvalid,
  onToggle, panelCloseStatesEditMode, defaultOpenChange,
  deleteAccordion, accordions, isDragging }) => {
  const textareaRef = useRef(null);

  const handleTextContentChange = (accordionId, contentType, rawContentState) => {
    saveTextContent(accordionId, contentType, { rawContentState });
  };

  const handleTitleTextContentChange = (accordionId, contentType, text) => {
    const rawContentState = {
      blocks: [
        {
          key: 'db2mm',
          text,
          type: 'header-three',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
    };
    handleTextContentChange(accordionId, contentType, rawContentState);
  };

  const onCheckboxChange = (accordionId, checkedValue) => {
    defaultOpenChange(accordionId, checkedValue);
  };

  const autoResize = () => {
    const textarea = textareaRef.current;
    textarea.style.height = '36px';
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  const handleInputChange = () => {
    autoResize();
  };

  const handleKeyDown = (e) => {
    if (e.code === 'Backspace' || e.code === 'Delete') {
      setTimeout(autoResize, 0);
    }
  };

  useEffect(() => {
    autoResize();
  }, []);

  return (
    <div className={styles.editorContainer}>
      <div className={styles.editorHeader}>
        <span>
          <PlaceholderIcon.GridIcon
            width="24"
            height="24"
            fill="#686868"
          />
        </span>
        <textarea
          value={item.title.blocks[0].text}
          onChange={e => handleTitleTextContentChange(item.id, 'title', e.target.value)}
          className={`${styles.accordionTitleInput} ${isTitleInvalid ? styles.invalidInput : ''}`}
          ref={textareaRef}
          onKeyDown={handleKeyDown}
          onInput={handleInputChange}
        />
        <button
          type="button"
          onClick={() => onToggle(item.id)}
          className={styles.toggleButton}
          style={isDragging ? { visibility: 'hidden' } : { visibility: 'visible' }}
          data-testid="toggle-button"
        >
          <PlaceholderIcon.DownChevron
            className={!panelCloseStatesEditMode[item.id] ? styles.rotateUp : styles.rotateDown}
            width="16"
            height="16"
            fill="#686868"
          />
        </button>
      </div>
      <PanelComponent
        id={item.id}
        isExpanded={!panelCloseStatesEditMode[item.id]}
        panelClass={styles.customPanel}
        panelCollapseClass={styles.panelCollapse}
        panelBodyClass={styles.customPanelBody}
        onToggle={() => onToggle(item.id)}
      >
        <div className={styles.textEditorContainer}>
          <div className={`${styles.richTextEditor} ${isBodyInvalid ? styles.invalidInput : ''}`}>
            <EditableRichText
              editorKey={`${item.id}-body`}
              editing={isEditing}
              onChange={data => handleTextContentChange(item.id, 'body', data)}
              rawContentState={item.body}
            />
          </div>
        </div>
        <div className={styles.accordionConfigureItem}>
          <span className={styles.defaultOpen}>
            <input
              type="checkbox"
              onChange={event => onCheckboxChange(item.id, event.target.checked)}
              checked={item.defaultOpen}
              className={styles.defaultOpenCheckbox}
              name={`defaultOpen${item.id}`}
              id={`defaultOpen${item.id}`}
            />
            <label className={styles.defaultOpenLabel} htmlFor={`defaultOpen${item.id}`}>Default Open</label>
          </span>
          <button
            type="button"
            onClick={() => deleteAccordion(item.id)}
            className={styles.deleteButton}
            disabled={accordions.length === 1}
            style={accordions.length === 1 ? { visibility: 'hidden' } : { visibility: 'visible' }}
            data-testid="delete-button"
          >
            <PlaceholderIcon.TrashIcon
              width="24"
              height="24"
              fill="#FF0000"
            />
          </button>
        </div>
      </PanelComponent>
    </div>
  );
};

AccordionEditItem.propTypes = propTypes;
AccordionEditItem.defaultProps = defaultProps;

export default AccordionEditItem;
